import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import {
  Center,
  Indicator,
  ButtonsContainer,
} from 'legacyComponents/styled/lib';
import { SocialStats } from 'legacyComponents/layout/socialStats';
import FormActionButton from 'libs/forms/views/formActionButton';

import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';
import { ProfileName as CollectionName } from 'apps/profile/views/profileName';
import { ProfileDescription as CollectionDescription } from 'apps/profile/views/profileDescription';
import { Follow } from 'apps/content/views/follow';
import { Button } from 'components';
import { withNamespaces, Trans } from 'react-i18next';

export const CollectionOverviewIndicator = () => (
  <div style={{ paddingTop: '15px' }}>
    <Indicator width='260px' height='27px' margin='0px auto' />
    <Indicator width='600px' height='22px' margin='10px auto 0px auto' />
  </div>
);

@withNamespaces()
@observer
export class CollectionOverview extends React.Component {
  render() {
    const { collection } = this.props;
    const { editing, form, canUpdate, Delete } = collection;

    return (
      <div style={{ paddingTop: '15px' }}>
        <CollectionName app={collection} fieldName='name' formStore={form} />
        <div style={{ width: '100%', height: '4px' }}></div>
        <CollectionDescription
          app={collection}
          fieldName='description'
          formStore={form}
        />
        {editing ? (
          <div style={{ width: '100%', height: '10px' }}></div>
        ) : (
          <SocialStats app={collection} />
        )}
        <Center>
          {canUpdate ? (
            editing ? (
              <Center>
                <FormActionButton
                  formStore={collection.form}
                  buttonHandler={collection.Cancel}
                  buttonText='Cancel'
                  variant='secondary'
                  marginRight='6px'
                  outline
                />
                <FormActionButton
                  formStore={collection.form}
                  buttonHandler={collection.Save}
                  buttonText='Save'
                  buttonTextPosting='Saving'
                  marginLeft='6px'
                />
              </Center>
            ) : !['s', 'xs'].includes(clientStore.activeBreakPoint) ? (
              <ButtonsContainer>
                <Button
                  text={<Trans>Edit</Trans>}
                  outline
                  onClick={() => collection.Edit()}
                />
                <Button
                  variant='destructive'
                  onClick={() =>
                    modalStore.SetModalComponent(ConfirmAction, {
                      callBack: Delete,
                      title: 'delete this Collection?',
                      undo: false,
                    })
                  }
                  icon='delete'
                  ariaLabel='Delete this Collection'
                />
              </ButtonsContainer>
            ) : (
              ''
            )
          ) : (
            <Follow content={collection.content} />
          )}
        </Center>
      </div>
    );
  }
}

CollectionOverview.propTypes = {
  collection: PropTypes.object,
  t: PropTypes.func,
};
